import { useState } from 'react';
import { type PreconfiguredResponse } from '@rsos/reduxDataStore/src/features/preconfiguredMessages/preconfiguredMessagesAPI';

export type SelectedPreconfiguredMessage = {
  message: PreconfiguredResponse;
  isSending: boolean;
} | null;

const usePreconfiguredMessageActions = () => {
  const [isAllMessagesVisible, setIsAllMessagesVisible] = useState(false);
  const [selectedPreconfiguredMessage, setSelectedPreconfiguredMessage] =
    useState<SelectedPreconfiguredMessage>(null);

  const handleMessageAction = (
    selectedMessage: PreconfiguredResponse,
    isSending: boolean,
  ) => {
    setIsAllMessagesVisible(false);
    setSelectedPreconfiguredMessage({ message: selectedMessage, isSending });
  };

  return {
    isAllMessagesVisible,
    setIsAllMessagesVisible,
    selectedPreconfiguredMessage,
    setSelectedPreconfiguredMessage,
    onCopyToChat: (msg: PreconfiguredResponse) =>
      handleMessageAction(msg, false),
    onSendMessage: (msg: PreconfiguredResponse) =>
      handleMessageAction(msg, true),
  };
};

export default usePreconfiguredMessageActions;
